module.exports = __webpack_public_path__ + "img/so.06815de7.svg";